module.exports = __webpack_public_path__ + "img/bg-cat.642f0ab4.jpg";